import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { updateOrderManualAction, fetchOrderFaxData } from '../../../../services/clinicPortalServices/orderEditService';
import { notifyFacilityViaEmail, notifyFacilityViaSMS } from '../../../../services/clinicPortalServices/reportService';

import RecordDetails from '../../../common/RecordDetails';
const panelStyles = { overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 }, panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' }, header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' }, title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' }, body: { padding: '20px', flex: 1 }, section: { marginBottom: '20px' }, sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' }, dl: { display: 'grid', gridTemplateColumns: '150px 1fr', rowGap: '8px', margin: 0 }, dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' }, dd: { fontSize: '13px', color: '#222', margin: 0 }, editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' }, closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' } };

export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            orderId: props.data._id,
            manual_action: props.data.manual_action
        };
    }

    handleShow = () => {
        this.setState({ show: true });
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleOrderEditChanges = () => {
        const editParams = {
            orderId: this.state.orderId,
            manualAction: this.state.manual_action
        };
        updateOrderManualAction(editParams).then((data) => {
            this.handleClose();
            // call refresh grid function
            if (this.props.context && this.props.context.componentParent) {
                this.props.context.componentParent.loadGridData();
            }
        });
    };

    handleFax = () => {
        fetchOrderFaxData(this.state.orderId).then((response) => {
            alert(response.message);
        });
    };

    handleEmail = () => {
        if (this.props.data.facility_id.contact_email) {
            let apiData = {
                lab_order_id: this.props.data.lab_order_id,
                email: this.props.data.facility_id.contact_email
            };
            notifyFacilityViaEmail(apiData).then((response) => {
                if (response.status === 200) {
                    const editParams = {
                        orderId: this.state.orderId,
                        manualAction: 'Contacted Physician Via Email'
                    };
                    updateOrderManualAction(editParams).then((data) => {
                        this.handleClose();
                        // call refresh grid function
                        if (this.props.context && this.props.context.componentParent) {
                            this.props.context.componentParent.loadGridData();
                        }
                    });
                }
            });
        } else {
            alert('That facility contact email is not provided yet');
        }
    };

    handleSMS = () => {
        if (this.props.data.facility_id.phone_no) {
            let apiData = {
                lab_order_id: this.props.data.lab_order_id,
                phone_no: this.props.data.facility_id.phone_no
            };
            notifyFacilityViaSMS(apiData).then((response) => {
                if (response.status === 200) {
                    const editParams = {
                        orderId: this.state.orderId,
                        manualAction: 'Contacted Physician Via SMS'
                    };
                    updateOrderManualAction(editParams).then((data) => {
                        this.handleClose();
                        // call refresh grid function
                        if (this.props.context && this.props.context.componentParent) {
                            this.props.context.componentParent.loadGridData();
                        }
                    });
                }
            });
        } else {
            alert('That facility phone number is not provided yet');
        }
    };

    renderPanel() {
        const d = this.props.data;
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Notification Details</h5>
                        <div>
                            <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}><i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit</button>
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}><i className="fas fa-times"></i></button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Order Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Requisition</dt><dd style={panelStyles.dd}>{d.lab_order_id || '—'}</dd>
                                <dt style={panelStyles.dt}>Facility</dt><dd style={panelStyles.dd}>{(d.facility_id && d.facility_id.name) || d.facility_source || '—'}</dd>
                                <dt style={panelStyles.dt}>Manual Action</dt><dd style={panelStyles.dd}>{d.manual_action || '—'}</dd>
                            </dl>
                        </div>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Contact Actions</div>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                <button style={{ ...panelStyles.editBtn, background: '#17a2b8' }} onClick={() => { this.setState({ showPanel: false }); this.handleFax(); }}><i className="fa fa-fax" style={{ marginRight: 5 }}></i>Fax</button>
                                <button style={{ ...panelStyles.editBtn, background: '#28a745' }} onClick={() => { this.setState({ showPanel: false }); this.handleEmail(); }}><i className="fa fa-envelope" style={{ marginRight: 5 }}></i>Email</button>
                                <button style={{ ...panelStyles.editBtn, background: '#6f42c1' }} onClick={() => { this.setState({ showPanel: false }); this.handleSMS(); }}><i className="fa fa-sms" style={{ marginRight: 5 }}></i>SMS</button>
                            </div>
                        </div>
                    
                        <RecordDetails data={d} exclude={['facility_id', 'facility_source', 'lab_order_id', 'manual_action', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Order
        </Tooltip>
    );

    renderTooltipFax = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Fax Order
        </Tooltip>
    );

    renderTooltipEmail = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Email to Facility
        </Tooltip>
    );

    renderTooltipSMS = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Send SMS to Facility
        </Tooltip>
    );

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Notification</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                    <button onClick={this.handleShow} className="edit-order-btn">
                        <i className="fas fa-pen"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipFax}>
                    <button className="edit-order-btn" onClick={this.handleFax}>
                        <i className="fa fa-fax" aria-hidden="true"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEmail}>
                    <button className="edit-order-btn" onClick={this.handleEmail}>
                        <i className="fa fa-envelope" aria-hidden="true"></i>
                    </button>
                </OverlayTrigger>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipSMS}>
                    <button className="edit-order-btn" onClick={this.handleSMS}>
                        <i className="fa fa-sms" aria-hidden="true"></i>
                    </button>
                </OverlayTrigger>

                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Order Action</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form>
                            <div className="row form-row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Action</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="manual_action"
                                            value={this.state.manual_action}
                                            onChange={this.handleChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={this.handleOrderEditChanges}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </ModalStyled>
            </div>
        );
    }
}
